import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import media from 'src/styles/media';

const ContentBlockFull = ({ children, title, subtitle }) => {
  return (
    <Root>
      {title && <Title>{title}</Title>}
      {subtitle && <Subtitle>| {subtitle} |</Subtitle>}
      <Content>{children}</Content>
    </Root>
  );
};

ContentBlockFull.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  center: PropTypes.bool,
};

const Root = styled.div`
  padding-top: 130px;
  padding-bottom: 140px;
  background: ${({ theme }) => theme.colorBackground};
  color: #fff;
  text-align: center;
`;

const Title = styled.h2`
  margin-bottom: 5px;
  font-size: 36px;
  text-transform: uppercase;
`;

const Subtitle = styled.h4`
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.fontBold};
  font-size: 11px;
  letter-spacing: 1.8px;
`;

const Content = styled.div`
  margin-top: 90px;
  p {
    line-height: 1.75;
    margin: 0 auto;
    margin-bottom: 25px;
    max-width: 525px;
    @media (max-width: ${media.md}) {
      max-width: 100%;
    }
  }
`;

export default ContentBlockFull;



// WEBPACK FOOTER //
// ./src/components/ContentBlockFull.js